export default __webpack_public_path__ + "static/media/indulge-my-passions.d3214545.svg";